import * as runtime from '@/api/runtime'
import {
  CreateOrderListRequest,
  CreateOrderListRequestToJSON,
  CreateOrderListSelectionRequest,
  CreateOrderListSelectionRequestToJSON,
  DeleteOrderListRequest,
  DeleteOrderListRequestToJSON,
  DeleteOrderListSelectionRequest,
  DeleteOrderLIstSelectionRequestToJSON,
  exists,
  GetOrderList,
  GetOrderListFromJSON,
  HTTPBody,
  HTTPQuery,
  OrderListEditAliveRequest,
  OrderListEditAliveRequestToJSON,
  OrderListEditToken,
  OrderListEditTokenFromJSON,
  OrderOrderListRequest,
  OrderOrderListRequestToJSON,
  RejectOrderListSelectionRequest,
  RejectOrderListSelectionRequestToJSON,
  SearchOrderList,
  SearchOrderListFromJSON,
  SearchOrderListRequest,
  SearchOrderListRequestToJSON,
  UpdateOrderListRequest,
  UpdateOrderListRequestToJSON,
  UpdateOrderListSelectionDetailsRequest,
  UpdateOrderListSelectionDetailsRequestToJSON,
  UpdateOrderListSelectionsRequest,
  UpdateOrderListSelectionsRequestToJSON
} from '@/api'

export class OrderListApi extends runtime.BaseAPI {
  /**
   * 発注リストを作成する
   * 発注リスト作成
   */
  async createOrderList(request: CreateOrderListRequest): Promise<number> {
    const bodyParameters: HTTPBody = CreateOrderListRequestToJSON(request)
    const response = await this.requestPost('/order-list', bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      exists(jsonValue, 'order_cart_id') ? jsonValue.order_cart_id : 0
    ).value()
  }

  /**
   * 発注リストを検索する
   * 発注リスト検索
   */
  async searchOrderList(
    request: SearchOrderListRequest
  ): Promise<SearchOrderList[]> {
    const queryParameters: HTTPQuery = SearchOrderListRequestToJSON(request)
    const response = await this.requestGet(
      '/order-list/search',
      Object.fromEntries(
        Object.entries(queryParameters).filter(value => value[1] !== undefined)
      )
    )
    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SearchOrderListFromJSON)
    ).value()
  }

  /**
   * 発注リストidにより発注リストを削除する
   * 発注リスト削除
   */
  async deleteOrderList(
    request: DeleteOrderListRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: HTTPBody = DeleteOrderListRequestToJSON(request)
    const response = await this.requestDelete(
      `/order-list/${request.id}`,
      bodyParameters
    )
    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リストidにより、発注リストを取得する
   * 発注リスト取得
   */
  async getOrderList(id: string): Promise<GetOrderList> {
    const response = await this.requestGet(`/order-list/${id}`)
    return new runtime.JSONApiResponse(response, jsonValue =>
      GetOrderListFromJSON(jsonValue)
    ).value()
  }

  /**
   * 発注リストidにより発注リストを更新する
   * 発注リスト更新
   */
  async updateOrderList(
    request: UpdateOrderListRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateOrderListRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/order-list/${bodyParameters.id}`,
      bodyParameters
    )
    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト編集開始
   */
  async startOrderListEdit(id: number): Promise<OrderListEditToken> {
    const response = await this.requestPut(`/order-list/${id}/edit/start`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      OrderListEditTokenFromJSON(jsonValue)
    ).value()
  }

  /**
   * 発注リスト編集終了
   */
  async endOrderListEdit(id: number): Promise<runtime.VoidApiResponse> {
    const response = await this.requestPut(`/order-list/${id}/edit/end`)

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト編集中であることを送信
   */
  async aliveOrderListEdit(
    request: OrderListEditAliveRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = OrderListEditAliveRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/order-list/${request.id}/edit/alive`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注選定候補を更新する
   * 発注選定候補更新
   */
  async updateOrderListSelections(
    request: UpdateOrderListSelectionsRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateOrderListSelectionsRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/order-list/${bodyParameters.id}/selections`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注選定候補を却下する
   * 発注選定候補却下
   */
  async rejectOrderListSelection(
    request: RejectOrderListSelectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = RejectOrderListSelectionRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/order-list/${bodyParameters.list_id}/selections/${bodyParameters.selection_id}/reject`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注選定候補を削除する
   * 発注選定候補削除
   */
  async deleteOrderListSelection(
    request: DeleteOrderListSelectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteOrderLIstSelectionRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/order-list/${bodyParameters.list_id}/selections/${bodyParameters.selection_id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リストを発注する
   * 発注リスト発注
   */
  async orderOrderList(
    request: OrderOrderListRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = OrderOrderListRequestToJSON(
      request
    )
    const response = await this.requestPost(
      `/order-list/${bodyParameters.id}/order`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注リスト選定候補を作成する
   * 発注リスト選定候補作成
   */
  async createOrderListSelection(
    request: CreateOrderListSelectionRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = CreateOrderListSelectionRequestToJSON(
      request
    )
    const response = await this.requestPost(
      `/order-list/${bodyParameters.id}/selections`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  /**
   * 発注選定候補詳細を更新する
   * 発注選定候補詳細更新
   */
  async updateOrderListSelectionDetails(
    request: UpdateOrderListSelectionDetailsRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateOrderListSelectionDetailsRequestToJSON(
      request
    )
    const response = await this.requestPut(
      `/order-list/${bodyParameters.list_id}/selections/${bodyParameters.selection_id}`,
      bodyParameters
    )
    return new runtime.VoidApiResponse(response)
  }
}
